enum InspectionActionTypes {
  RedTag = "red tag",
  GreenTag = "green tag",
  Reschedule = "reschedule",
  Schedule = "schedule",
  Cancel = "cancel",
}

export { InspectionActionTypes };
